import axios from "axios";
import config from "../config";
import { CarouselResponse } from "./ResponseModels/CarouselResponse";

export async function GetCarouselPublicWoModel(
  idPage: string,
  token: string | null
) {
  let response = null;

  if (token === null) {
    token = config.apiToken;
  }

  response = axios
    .get<CarouselResponse>(config.getCarouselPublicEndpoint, {
      params: {
        slug: token + "#" + idPage,
      },
    })
    .catch((e) => {
      // TODO manage
      console.error("There was an error!", e);
    });

  return response;
}
